<template>
  <div class="context-menu-container" ref="refContainer">
    <slot></slot>
    <Transition
      @beforeEnter="handleBeforeEnter"
      @enter="handleEnter"
      @afterEnter="handleAfterEnter"
      @leave="handleLeave"
    >
      <div
        class="menu"
        v-if="showMenu"
        ref="refMenu"
        :style="menuStyle"
        @click.stop
      >
        <ul class="menu-list">
          <li
            v-for="(item, index) in menu"
            :key="index"
            :class="['menu-item', {'menu-item-disabled': item.disabeld}]"
            @click="handleClick(item)"
          >
            {{ item.label }}
          </li>
        </ul>
      </div>
    </Transition>
  </div>
</template>

<script>
/**
 * 右键菜单组件
 * 
 * @param {disabled} 是否禁用菜单
 * @param {menu.label} 子菜单文本
 * @param {menu.disabled} 子菜单是否禁用
 * @param {menu.action} 子菜单行为标识
 */
export default {
  props: {
    disabeld: Boolean,  //是否禁用菜单
    menu: { type: Array, default: () => [] }, //操作菜单列表
  },
  data() {
    return {
      showMenu: false, //菜单显隐开关
      x: 0, //菜单横向坐标
      y: 0, //菜单纵向坐标
    };
  },
  computed: {
    menuStyle() {
      return {
        left: this.x + "px",
        top: this.y + "px",
      };
    },
  },
  mounted() {
    if (this.disabeld) return;
    const div = this.$refs.refContainer;
    div?.addEventListener("contextmenu", this.handleContextMenu);
    // 捕获阶段关闭所有菜单
    window.addEventListener("click", this.closeMenu);
    // window.addEventListener("click", this.closeMenu, true);
    window.addEventListener("contextmenu", this.closeMenu, true);
  },
  beforeDestroy() {
    if (this.disabeld) return;
    const div = this.$refs.refContainer;
    div?.removeEventListener("contextmenu", this.handleContextMenu);
    // 捕获阶段关闭所有菜单
    window.removeEventListener("click", this.closeMenu);
    // window.removeEventListener("click", this.closeMenu, true);
    window.removeEventListener("contextmenu", this.closeMenu, true);
    this.$refs.refMenu?.remove();
  },
  methods: {
    // 打开菜单
    handleContextMenu(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      this.showMenu = true;
      this.x = ev.clientX;
      this.y = ev.clientY;
    },
    // 关闭菜单
    closeMenu() {
      this.showMenu = false;
    },
    // 菜单进入前回调
    handleBeforeEnter(el) {
      el.style.height = 0;
    },
    // 菜单进入回调
    handleEnter(el) {
      el.style.height = "auto";
      const w = el.clientWidth;
      const h = el.clientHeight;
      document.body.append(el);

      // 处理边界情况
      const { innerWidth, innerHeight } = window;
      if (this.x + w > innerWidth) this.x = this.x - w;
      if (this.y + h > innerHeight) this.y = this.y - h;
      el.style.height = 0;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          el.style.height = h + "px";
          el.style.transition = "all 0.15s linear";
        });
      });
    },
    // 菜单进入后回调
    handleAfterEnter(el) {
      // el.style.transition = 'none';
    },
    // 菜单离开回调
    handleLeave(el) {
      el.style.height = "0px";
    },
    // 点击菜单回调
    handleClick(item) {
      if (item.disabeld) return;
      this.showMenu = false;
      this.$emit("select", item);
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
